export default __webpack_public_path__ + "static/media/aueldr.f671f8e9.png";